import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import tr from './locales/tr.json';
import en from './locales/en.json';
import ru from './locales/ru.json';

// Custom language detector with geolocation fallback
const locationDetector = {
  name: 'locationDetector',
  lookup() {
    // Try to get user's country from timezone or browser language
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const browserLang = navigator.language || navigator.userLanguage;
    
    // Check if Turkey
    if (timezone?.includes('Istanbul') || browserLang?.startsWith('tr')) {
      return 'tr';
    }
    
    // Check if Russia
    if (timezone?.includes('Moscow') || browserLang?.startsWith('ru')) {
      return 'ru';
    }
    
    // Default to English for other locations
    return 'en';
  },
  cacheUserLanguage(lng) {
    localStorage.setItem('i18nextLng', lng);
  }
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(locationDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: tr },
      en: { translation: en },
      ru: { translation: ru }
    },
    fallbackLng: 'tr',
    detection: {
      order: ['localStorage', 'locationDetector', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
